// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"6454":"Widgets","6821":"plone-volto-components-theme-InjectPloneComponentsCSS-InjectPloneComponentsCSS","7051":"plone-volto-components-manage-Controlpanels-Aliases"}[chunkId] || chunkId) + "." + {"6129":"dcba877d","6454":"62da82f2","6821":"9b025ce8","7051":"62da82f2"}[chunkId] + ".chunk.css";
};